import { route } from '../helpers';

import { PromotionPages } from '../../constants/AppConstants';

export default route(PromotionPages.PROMOTION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/promotion/Promotion').default);
        }, 'promotion');
    }
});
